const truncateText = (text, maxLength = 50) => {
  if (!text) return 'N/A';
  return text.length > maxLength ? text.slice(0, maxLength) + '...' : text;
};

const capitalizeFirst = (phrase) => {
  if (typeof phrase !== 'string') return '';
  const array = phrase.toLowerCase().split("");
  array[0] = array[0]?.toUpperCase();
  return array.join("");
};

const clipText = (text, clipLength = 12) => {
  if (!text) return '';

  if (text.length <= clipLength) return text;

  return text.slice(0, clipLength).trimEnd() + '.';
};

const applyTextTransform = (text, { clipLength = 12, transform = 'capitalize' } = {}) => {
  if (!text) return '';

  switch (transform) {
    case 'uppercase':
      return text.toUpperCase();
    case 'lowercase':
      return text.toLowerCase();
    case 'capitalize':
      return capitalizeFirst(text);
    case 'clip':
      return clipText(text, clipLength);
    default:
      return text;
  }
};

export const textFormatter = (
  text,
  { clipLength = 12, maxLength = 50, textTransform = 'capitalize', separator = ', ' } = {}
) => {
  let input;

  if (Array.isArray(text)) {
    input = text.map(item => {
      const truncated = truncateText(item, maxLength);
      return applyTextTransform(truncated, { clipLength, transform: textTransform });
    }).join(separator);
  } else {
    const truncated = truncateText(text, maxLength);
    input = applyTextTransform(truncated, { clipLength, transform: textTransform });
  }

  return input;
};


export const createPercentFormatter = ({minimumFractionDigits = 1, maximumFractionDigits = 1 } = {}) =>
  new Intl.NumberFormat("pt-BR", {
    style: "percent",
    minimumFractionDigits,
    maximumFractionDigits,
});

export const createIntFormatter = (maximumFractionDigits = 0) =>
  new Intl.NumberFormat("pt-BR", {
    maximumFractionDigits,
});

export const currencyFormatter = new Intl.NumberFormat("pt-BR", {
  style: "currency",
  currency: "BRL",
  minimumFractionDigits: 2,
  maximumFractionDigits: 2,
});

export const createDecimalFormatter = ({
  minimumFractionDigits = 0,
  maximumFractionDigits = 0,
  locale = "pt-BR",
} = {}) =>
  new Intl.NumberFormat(locale, {
    style: "decimal",
    minimumFractionDigits,
    maximumFractionDigits,
  });

const compactDecimalFormatter = createDecimalFormatter({ maximumFractionDigits: 1 });

export const compactCurrencyFormatter = (value) => {
  const number = Number(value) || 0;
  const abs = Math.abs(number);
  const sign = number < 0 ? "-" : "";

  if (abs >= 1_000_000_000) {
    return `${sign}R$ ${compactDecimalFormatter.format(abs / 1_000_000_000)} bi`;
  }

  if (abs >= 1_000_000) {
    return `${sign}R$ ${compactDecimalFormatter.format(abs / 1_000_000)} mi`;
  }

  if (abs >= 1_000) {
    return `${sign}R$ ${compactDecimalFormatter.format(abs / 1_000)} mil`;
  }

  return currencyFormatter.format(number);
};